import { render, staticRenderFns } from "./detail_old.vue?vue&type=template&id=3bc79a83&"
import script from "./detail_old.vue?vue&type=script&lang=js&"
export * from "./detail_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports